import { MutationTree } from 'vuex';
import { EAttachmentsMutation, IAttachmentState } from './attachments.types';

export const mutations: MutationTree<IAttachmentState> = {
  [EAttachmentsMutation.SetLoaded](state: IAttachmentState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EAttachmentsMutation.SetLoading](state: IAttachmentState, loading: boolean) {
    state.loading = loading;
  },
  [EAttachmentsMutation.SetState](state: IAttachmentState, newState: IAttachmentState) {
    Object.assign(state, newState);
  },
};
